import { keyBy } from 'lodash';
import { useMemo } from 'react';
import { GigData, UrlContext } from '@fiverr-private/seller_pages_toolbox';

export const useRelevantGigsOrder = (gigs: GigData[]) =>
    useMemo(() => {
        const urlGigParams = UrlContext.getUrlGigs();
        const urlGigRefSlug = UrlContext.getRefGigSlug();
        if (urlGigRefSlug) {
            urlGigParams.push(urlGigRefSlug);
        }

        const gigsMap = keyBy(urlGigParams, (item) => item.id || item.slug);
        return gigs.filter((gig) => gigsMap[gig.gig_id] || gigsMap[gig.cached_slug]).map((item) => item.gig_id);
    }, [gigs]);
